import React, { useState } from "react";
import RoiCalculatorWidget from "./RoiCalculatorWidget";
import Industries_carousel_pa from "./Industries_carousel_pa";
import Industries_carousel_global from "./industries_carousel_global";
import Modal_started from "../Home/Modal_started";
import { useTranslation } from "react-i18next";

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const Loyalty_new = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      tag: "Inventario al día",
      title: "Gestión de inventario automática",
      description:
        "Que reduzca pérdidas, avise cuando falten ingredientes y permita compras inteligentes.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-INVENTARIO-AUTOMATICA_kow1hl.png",
    },
    {
      tag: "Facturación electrónica",
      title: "Facturación digital eficiente",
      description:
        "Genera facturas electrónicas al instante, lleva un control de tus ventas y cumple con todos los requisitos fiscales sin complicaciones.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/FACTURACION-DIGITAL-EFICIENTE_bzc8pt.png",
    },
    {
      tag: "Control de mesas",
      title: "Gestión del personal",
      description:
        "Control de turnos, comisiones, rendimiento y roles dentro del sistema.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-PERSONAL_jzcmhm.png",
    },
    {
      tag: "InvuReport",
      title: "Reportes avanzados de ventas",
      description:
        "Gráficos y análisis por plato, turno, mes o empleado para tomar decisiones rápidas.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/REPORTES-AVANZADOS-DE-VENTAS_wzaucp.png",
    },
    {
      tag: "Control de mesas",
      title: "Control de mesas y reservas",
      description:
        "Visualización clara de ocupación, tiempos de permanencia y disponibilidad en tiempo real.",
      image:
        "https://img.invupos.com/webinvu/homenew/Whatsapp%20Catalogo-12%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Manejo de promociones",
      description:
        "Crear ofertas, combos y descuentos fácilmente sin afectar inventario ni contabilidad.",
      image:
        "https://img.invupos.com/webinvu/homenew/invu%20mockups%20multiple%20screens%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Para franquicias o sucursales",
      description:
        "Administración centralizada si tienen más de un local, con reportes consolidados.",
      image:
        "https://img.invupos.com/webinvu/homenew/1%202.png",
    },
  ];

  const integrations = "https://img.invupos.com/webinvu/Kds_new/INVU_POS_El_Salvador-9_3_t18s5r.png"

  const features1 = [
    { text: "Incrementa tickets" },
    { text: "Cocina siempre sincronizada" },
    { text: "Preparación más rápida" },
    { text: "Flujo de trabajo eficiente" },
    { text: "Reduce errores" },
    { text: "Alerta de comanda" },
    { text: "Pedidos Online" },
    { text: "Reportes de cocina" },
    { text: "Mide los tiempos en cocina" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  // ✅ Siempre devuelve 3 cards, ciclando los índices con módulo
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % features.length;
      cards.push({ ...features[index], originalIndex: index });
    }
    return cards;
  };

  const faqs = [
    {
      question: "¿Qué es el KDS de Invu POS y cómo ayuda a mi restaurante?",
      answer:
        "El KDS de Invu POS es un sistema de pantallas de cocina que organiza todas tus órdenes en tiempo real. Elimina tickets impresos, reduce errores y acelera la salida de los platos. Todo entra ordenado, claro y con prioridades visibles para tu equipo",
    },
    {
      question: "¿El KDS funciona para cualquier tipo de restaurante?",
      answer:
        "Sí. Nuestro KDS se adapta a cocinas rápidas, cafeterías, dark kitchens, food trucks y restaurantes a gran escala. Puedes crear estaciones por categoría (cocina fría, caliente, bar, postres) y cada orden se envía automáticamente al área correcta. ",
    },
    {
      question: "¿Cómo se conecta el KDS con mi sistema actual?",
      answer:
        "El KDS está 100% integrado con Invu POS. Cada pedido que entra —sea en mesa, delivery o pickup— aparece de inmediato en la pantalla de cocina. No necesitas configuraciones complejas: solo conectas la pantalla y estás listo para trabajar.",
    },
    {
      question: "¿Puedo ver los tiempos de preparación y medir el rendimiento de mi cocina?",
      answer:
        "Sí. El KDS registra los tiempos de cada orden y te muestra estadísticas clave: platos más lentos, horas pico, tiempos promedio y desempeño por estación. Esto te permite optimizar tu operación y mejorar la experiencia del cliente. ",
    },
    {
        question: "¿Qué equipos necesito para usar el KDS? ",
        answer:
          "Puedes usar pantallas táctiles, tablets o monitores estándar. El sistema corre en la nube, por lo que no necesitas servidores ni instalaciones complicadas. Solo wifi y un dispositivo que ya tengas en tu cocina. ",
      },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isOpen, setIsOpen] = useState(false);
  const extendedFeatures = [...features, ...features, ...features];

      // const extendedFeatures = [...features, ...features, ...features]; 
      const featuresList = t("features1kdsnew", { returnObjects: true });
      const extendedFeaturesList = t("featuresecommercenew", { returnObjects: true });
      const faqList = t("faqslealtadnew", { returnObjects: true });
    
      const isMobile =
      typeof window !== "undefined" && window.innerWidth < 768;

      const location = useLocation();
      const prefix = useLocalePrefix();
    
    const cardsPerSlide = isMobile ? 1 : 3;
  return (
    <>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
    <div className="px-6 py-12 md:py-20">
  <div className="max-w-7xl mx-auto bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl">
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center px-6 lg:px-10">

      {/* Imagen (primera en LG) */}
      <div className="relative order-2 lg:order-1 flex justify-center">
        <img
          src="https://img.invupos.com/webinvu/loyalty_new/Group%201597880421.png"
          alt="Mockup Invu POS"
          className="rounded-2xl w-full max-w-xl h-[600px] object-contain"
        />
      </div>

      {/* Texto (segundo en LG) */}
      <div className="order-1 lg:order-2 space-y-5 lg:space-y-6 max-w-xl">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight mt-12">
        {t("loyaltytitle1")}{" "}
          <span className="text-blue-600">{t("loyaltyspan")} </span>{t("loyaltytitle2")}
        </h1>

        <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
          {t("loyaltydescription1")}
        </p>

        <button 
         onClick={() => {
          setIsOpen(true);
        }}
        className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-12 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
         {t("loyaltynewbutton1")}
        </button>
      </div>

    </div>
  </div>
</div>


<div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl  lg:px-8 lg:py-12">
        <h2 className="text-5xl sm:text-6xl font-extrabold text-[#1d1d1f] py-10 mb-8 md:mb-0 text-left md:text-center lg:text-left md:mb-6 lg:mb-0">
          {t("claulealtadbenefittitle")}{" "}
          <span className="hidden lg:inline">
            <br />
          </span>
          <span className="text-blue-600">
            {t("claulealtadbenefittitlespan")}
          </span>
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
          <div className=" lg:px-8 relative md:col-span-2 lg:col-span-2 items-center flex  justify-center md:justify-center">
            <div className="max-w-xl relative w-full h-[260px] lg:ml-0 ml-10">
              <div className="absolute top-[-40px] left-[-40px] w-full h-full bg-[#98b5f6] rounded-[2rem] z-0"></div>
              <div className="absolute top-[-20px] left-[-20px] w-full h-full bg-[#4c85f9] rounded-[2rem] z-0"></div>

              {/* Tarjeta principal */}
              <div className="relative bg-gradient-to-r from-[#0056FB] to-[#003395] text-white rounded-[2rem] p-6 w-full h-full z-10 shadow-md">
                <div className="flex justify-between items-start">
                  <h2 className="text-4xl font-bold leading-tight">
                    {t("claulealtadpointsactiontitle")}
                  </h2>
                  <div className="bg-white text-rose-500 rounded-full p-2">
                    <svg
                      className="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17 7l-10 10M17 17V7H7"
                      />
                    </svg>
                  </div>
                </div>
                <p className="mt-4 text-white/90 leading-relaxed text-2xl">
                  {t("claulealtadpointsactiondescription")}
                </p>
              </div>
            </div>
          </div>
          <div className="grid gap-6 md:col-span-2 lg:col-span-3">
            <div>
              <img
                className="w-full h-auto"
                src="https://img.invupos.com/clauweb/Loyalty/Post%20para%20Instagram%20recordatorio%20frase%20no%20olvidar%20amarillo%20naranja%201.png"
                alt="Promoción"
              />
            </div>
            {/* <div className="mt-8 text-center">
              <button
                class="inline-block rounded-full border border-[#FE7066] bg-[#FE7066] px-16 py-4 text-lg font-medium text-white hover:bg-transparent hover:text-[#FE7066] focus:ring-3 focus:outline-hidden"
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                {t("claulealtadpointscta")}
              </button>
            </div> */}
          </div>
        </div>
      </div>

      <div className="px-4 mx-auto md:max-w-full lg:max-w-screen-xl lg:px-8">
        <div className="rounded-3xl sm:p-6 bg-[#F1F1F1]">
          <div className="flex flex-col lg:flex-row px-4 py-5">
            <div className="lg:w-1/2 content-center">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div className="border-2 border-[#2C2D84] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelbronzetitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#2C2D84] mt-2">
                    x1
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelbronzepoints")}
                  </p>
                </div>
                <div className="border-2 border-[#E63E2D] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelsilvertitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#E63E2D] mt-2">
                    x3
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelsilverpoints")}
                  </p>
                </div>
                <div className="border-2 border-[#F2A343] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelgoldtitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#F2A343] mt-2">
                    x5
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelgoldpoints")}
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-6 lg:mb-0 lg:w-1/2 lg:pr-10 content-start lg:px-12 lg:mt-0 mt-6">
              <div className="text-gray-500 text-xl space-y-3 md:col-span-1 tracking-normal leading-relaxed">
                <h2 className="text-4xl sm:text-4xl font-extrabold text-[#1d1d1f]">
                  {t("claulealtadlevelstitle")}
                </h2>
                <p>{t("claulealtadlevelsdescription")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

<Industries_carousel_global/>


<div className="px-4 py-16 mx-auto md:max-w-full lg:max-w-screen-xl lg:px-8 mt-12">

  {/* SECCIÓN ORIGINAL */}
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">

    <div className="space-y-8">
      <div className="bg-[#F8F8F8] rounded-2xl p-10 space-y-8">
        <h3 className="text-5xl font-bold text-blue-600">
          {t("claulealtadpromoautomationtitle")}
        </h3>

        <p className="text-gray-500 text-2xl max-w-lg leading-relaxed">
          {t("claulealtadpromoautomationdescription")}
        </p>

        <div className="w-full max-w-xl h-[75px] flex overflow-hidden bg-[#EAEAEA] rounded-3xl">
          <div className="progress-stripes h-full"></div>
          <div className="w-[20%] h-full flex items-center justify-center text-[#f7901e] font-extrabold text-2xl">
            80%
          </div>
        </div>
      </div>
    </div>

    <div className="flex justify-center items-center">
      <img
        src="https://img.invupos.com/webinvu/loyalty_new/Frame%201707482089.png"
        className="w-96"
        alt="Invu POS"
      />
    </div>

  </div>

  {/* NUEVA SECCIÓN ABAJO */}
  <div className="mt-20 space-y-12">

    {/* BLOQUE SUPERIOR */}
    <div className="bg-[#F8F8F8] rounded-3xl p-12 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <h2 className="text-5xl font-bold leading-tight">
        {t("claulealtadctatitle1")} <span className="text-blue-600">{t("claulealtadctatitle1span")}</span> {t("claulealtadctatitle2")}
      </h2>

      <p className="text-gray-500 text-xl leading-relaxed max-w-xl">
        {t("claulealtadp1")}
        <br /><br />
        {t("claulealtadp2")}
      </p>
    </div>

    {/* CARDS */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

      <div className="bg-[#F2F2F2] rounded-3xl p-10 text-center space-y-6">
        <h3 className="text-3xl font-bold">
          {t("claulealtadcta1title")}
        </h3>
        <p className="text-gray-500 text-lg leading-relaxed">
          {t("claulealtadcta1description")}
        </p>
      </div>

      <div className="bg-[#F2F2F2] rounded-3xl p-10 text-center space-y-6">
      <h3 className="text-3xl font-bold">
          {t("claulealtadcta2title")}
        </h3>
        <p className="text-gray-500 text-lg leading-relaxed">
          {t("claulealtadcta2description")}
        </p>
      </div>

    </div>

  </div>
</div>


      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
  <div className="max-w-7xl mx-auto">
    {/* Header */}
    <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
        {t("reasons_title")}
      </h1>

      <button
        onClick={() => {
          setIsOpen(true);
        }}
        className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
      >
        {t("reasons_cta")}
      </button>
    </div>

    {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
        {extendedFeaturesList.map((feature, idx) => (
          <div
            key={idx}
            className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
            style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
          >
            {/* Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
              {/* Brillo diagonal */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

              {/* Borde brillante */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

              {/* Tag */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-blue-600 font-semibold text-sm">
                  {feature.tag}
                </span>
                <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                {feature.description}
              </p>

              {/* Image */}
              <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                />
              </div>

              {/* Plus Button */}
              <div>
                <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Anterior"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Siguiente"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Indicadores */}
      <div className="flex justify-center gap-2 mt-6">
        {features.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`h-2 rounded-full transition-all ${
              idx === currentSlide
                ? "w-8 bg-blue-600"
                : "w-2 bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Ir a slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  </div>
</div>

<div className="px-6 mt-16">
        <div className="max-w-7xl mx-auto bg-[#F3F3F3] rounded-3xl shadow-xl p-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Imagen reducida (igual estilo que el CTA anterior) */}
            <div className="order-2 lg:order-1 flex justify-center">
              <img
                className="w-64 md:w-80 lg:w-[550px] drop-shadow-xl"
                src="https://img.invupos.com/webinvu/homenew/Group%201171275526.png"
                alt="POS"
              />
            </div>

            {/* Contenido */}
            <div className="order-1 lg:order-2 space-y-8">
              <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-gray-900">
                {t("homesectioncta2title1")}
              </h2>

              <p className="text-lg md:text-2xl text-gray-700 leading-relaxed">
                {t("homesectioncta2description")}
              </p>

              <button  
                onClick={() => {
                  setIsOpen(true);
                }}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-10 py-4 rounded-full shadow-md hover:scale-105 transition">
                {t("homesectioncta2button")}
              </button>
            </div>
          </div>
        </div>
      </div>

<div className="min-h-screen bg-gray-100 py-16 px-6 mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Card - Aliados */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden">
              {/* Header */}

              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
                <span className="text-blue-600">{t("kioskcta1span")}</span> {t("kioskcta1title")}
              </h2>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed mb-12">
             {t("kioskcta1description")}
              </p>

              {/* Imagen CLAU.IO */}
              <div className="relative bg-gray-50 rounded-2xl overflow-hidden h-80 mb-8 flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Kiosk_new/img3.png"
                  alt="Plataforma CLAU.IO"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* CTA Button */}
              <Link
              to={`${prefix}` + "/productos/quioscos"}
              onClick={() => window.scrollTo(0, 0)}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
               {t("kioskcta1button")}
              </Link>
            </div>

            {/* Right Card - Loyalty */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden flex flex-col">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                  <span className="text-black">{t("kioskcta2title")} </span>
                  <span className="text-blue-600">{t("kioskcta2span")}</span>
                </h2>

                {/* Description */}
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {t("kioskcta2description")}
                </p>

                {/* CTA Button */}
                <Link
                to={`${prefix}` + "/productos/programa-de-lealtad"}
                onClick={() => window.scrollTo(0, 0)}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-24 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  {t("kioskcta2button")}
                </Link>
              </div>

              {/* Imagen de celulares */}
              <div className="relative flex-1 flex items-end justify-center mt-8">
                <div className="w-full h-96 bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center">
                  <img
                    src="https://img.invupos.com/webinvu/Kiosk_new/img4.png"
                    alt="Apps móviles Loyalty"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="min-h-screen bg-white py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Imagen FAQ Ecommerce */}
            <div className="flex justify-center lg:justify-center">
              <img
                src="https://img.invupos.com/webinvu/loyalty_new/El%20Salvador%20redes%20sociales-2%201.png"
                alt="Preguntas frecuentes Ecommerce"
                className=" block w-full max-w-[420px] h-auto object-contain"
              />
            </div>

            {/* Right Side - FAQ Section */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
                {t("loyaltyfaqnew")}
              </h2>

              {/* FAQ Items */}
              <div className="space-y-4">
                {faqList.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full py-6 flex items-center justify-between text-left hover:text-gray-600 transition-colors"
                    >
                      <span className="text-lg font-medium text-gray-900 pr-4">
                        {faq.question}
                      </span>
                      <span className="text-2xl text-gray-500 flex-shrink-0">
                        {openIndex === index ? "−" : "+"}
                      </span>
                    </button>
                    {openIndex === index && (
                      <div className="pb-6 text-gray-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Banner */}
          <div className=" relative bg-gradient-to-r from-[#0056FB] to-[#003395] rounded-3xl p-12 overflow-hidden max-w-6xl mx-auto mt-14">
            {/* Decorative Circle */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 w-64 h-64 opacity-20">
              <img src="https://img.invupos.com/webinvu/Kds_new/logo-INVU-POS-blanco_1_7_dvfhgc.png" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto text-center">
              <h3 className="text-3xl lg:text-5xl font-bold text-white mb-8 leading-tight">
              {t("loyaltycta3")}
              </h3>
              <button 
               onClick={() => {
                setIsOpen(true);
              }}
              className="bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-full transition-colors text-lg uppercase tracking-wide">
                {t("kdscta3button")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loyalty_new;